import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"


export const DailyComplaint = (props) => {
    const { DataObj } = props
    const {
      Countdata,
      isCountLoading,
      PlanationDetailsCountdata,
      YearValue,
      MonthValue,
      ZoneValue,
      DashSelect,
      Language,
  
    } = DataObj
    const { t } = useTranslation()
    const navigate = useNavigate();

    return (
        <div className="col-12 col-lg-12 px-2">
            <div className="row bg-white pb-3 pb-lg-0 rounded " >
              <div className="col-12 col-md-12 col-lg-12  pb-0 mt-1 cursor-pointer"
                    onClick={() => navigate(`/TodaysTotalComplaintGrid?DashSelect=${DashSelect}&Flag=Todays_Complaint`)}
                >
                    <div className="p-2 p-lg-0" >
                        <div className="col-12 col-md-12 pb-0 bg_daily_complaint_img">
                            <div className="pt-3 pb-1 px-2 eic_background_style" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                                <div className="row ">
                                    <div className="col-10">
                                        <h6 className="text-dark">{t('EncroachmentDashboard.TodaysTotalComplate')}</h6>
                                        <h2 className="pt-1 pt-lg-0 fw-bold text-danger">{Countdata && Countdata.Todays_Complaint ? Countdata.Todays_Complaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* Today’s Closed Complaint */}
                <div className="col-12 col-md-12 col-lg-12 pt-3 pt-lg-3 pb-0 mt-1 cursor-pointer"
                    onClick={() => navigate(`/TodaysClosedComplaintGrid?DashSelect=${DashSelect}&Flag=Todays_ClosedComplaint`)}
                >
                    <div className="p-2 p-lg-0" >
                        <div className="col-12 col-md-12 pb-0 bg_daily_complaint_img_new">
                            <div className="pt-3 pb-1 px-2 eic_background_style" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                                <div className="row ">
                                    <div className="col-10">
                                        <h6 className=" text-dark noWrap">{t('EncroachmentDashboard.TodaysClosedComplaint')}</h6>
                                        <h2 className="pt-1 pt-lg-0 fw-bold text-danger">{Countdata && Countdata.Todays_ClosedComplaint ? Countdata.Todays_ClosedComplaint.toFixed(0) : '0'}</h2>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}